// SidebarMenu.js

import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { gql } from '@apollo/client';
import { client } from "../../../client";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import UserModal from "./UserModal";

// DataGrid

import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Box, InputBase, IconButton } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const GET_USER_LIST = gql`
  query getUserListByAdmin(
    $id: Int
    $name: String
    $email: String
    $phone_number: String
    $type: Type
    $region1: String
    $region2: String
    $page: Int
    $pageSize: Int
  ) {
    getUserListByAdmin(
      id: $id
      name: $name
      email: $email
      phone_number: $phone_number
      type: $type
      region1: $region1
      region2: $region2
      page: $page
      pageSize: $pageSize
    ) {
      id
      name
      email
      phone_number
      type
      region1
      region2
      ad_agreement
      current_point
      created_at
    }
  }
`;

const UserPage = () => {
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  const fetchData = async () => {
    await client
      .query({
        query: GET_USER_LIST,
        variables: {
          page: 1,
          pageSize: 100000,
          // Add other variables as needed
        },
        fetchPolicy: "no-cache",
      })
      .then((res) => {
        console.log(res);
        console.log("refetchData...", res);
        setUserList(res.data.getUserListByAdmin);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  // const userList = data.getUserListByAdmin;
  const handleEditClick = (user) => {
    setSelectedUser(user);
    setModalOpen(!isModalOpen);
  };

  const handleCloseClick = () => {
    setModalOpen(false);
  };

  // DataGrid Columns

  const columns = [
    { field: "id", headerName: "ID", flex: 0.5 },
    { field: "name", headerName: "이름", flex: 1 },
    { field: "email", headerName: "이메일", flex: 1.5 },
    { field: "phone_number", headerName: "핸드폰번호", flex: 1 },
    { field: "type", headerName: "유형", flex: 0.7 },
    { field: "region1", headerName: "지역1", flex: 0.7 },
    { field: "region2", headerName: "지역2", flex: 0.7 },
    { field: "current_point", headerName: "잔액", flex: 0.7, type: "number" },
    {
      field: "created_at",
      headerName: "가입일",
      flex: 1,
      renderCell: (params) => {
        const timestamp = parseInt(params.value);
        return (
          <Box whiteSpace={"normal"}>
            {new Date(timestamp).toLocaleString("ko-kr")}
          </Box>
        );
      },
    },
    {
      field: "edit",
      headerName: "정보수정",
      flex: 0.7,
      renderCell: (params) => (
        <Button onClick={() => handleEditClick(params.row)}>수정</Button>
      ),
    },
  ];

  const handleExportCSV = () => {
    if (userList.length === 0) {
      alert("내보낼 데이터가 없습니다.");
      return;
    }

    // CSV 헤더 생성 (columns 정의를 기반으로)
    const header = columns
      .filter((col) => col.field !== "edit") // '정보수정' 버튼 열 제외
      .map((col) => col.headerName)
      .join(",");

    // CSV 데이터 행 생성
    const rows = userList.map((user) => {
      return columns
        .filter((col) => col.field !== "edit")
        .map((col) => {
          let value = user[col.field];
          if (col.field === "created_at") {
            value = new Date(parseInt(value)).toLocaleString("ko-kr");
          }
          // 쉼표나 줄바꿈이 포함된 문자열은 큰따옴표로 감싸기
          if (
            typeof value === "string" &&
            (value.includes(",") || value.includes("\n"))
          ) {
            value = `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        })
        .join(",");
    });

    const csvContent = `${header}\n${rows.join("\n")}`;
    const BOM = "\uFEFF"; // UTF-8 BOM (Byte Order Mark) - Excel에서 한글 깨짐 방지
    const blob = new Blob([BOM + csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "user_list.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <Box
        margin={"7px"}
        display={"flex"}
        height={"70px"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box ml={"5px"}>
          <h2>유저관리</h2>
        </Box>
        <Box>
          <Button
            variant="contained"
            startIcon={<FileDownloadIcon />}
            onClick={handleExportCSV}
            sx={{ mr: "5px" }}
          >
            CSV 내보내기
          </Button>
        </Box>
      </Box>
      <Box sx={{ height: "calc(100vh - 200px)", width: "100%" }}>
        <DataGrid
          rows={userList}
          columns={columns}
          components={{
            Toolbar: GridToolbar,
          }}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 100 },
            },
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          checkboxSelection
        />
      </Box>

      {/* Modal for Edit */}
      <UserModal
        isOpen={isModalOpen}
        handleCloseClick={handleCloseClick}
        refetchParentData={fetchData}
        data={selectedUser}
      ></UserModal>
    </div>
  );
};

export default UserPage;
